import { CSpinner } from '@coreui/react';

export const Loading = () => {
    return (
        <div className="pt-3 text-center">
            <CSpinner color="primary" grow={true} />
        </div>
    );
};
